import { useState, useEffect, useCallback } from 'react';
import { api } from '../api';
import DateBar, { today, daysAgo } from '../components/DateBar';
import StateTable from '../components/StateTable';

export default function StatesPage({ showToast }) {
  const [preset,  setPreset]  = useState(1);
  const [start,   setStart]   = useState(daysAgo(6));
  const [end,     setEnd]     = useState(today);
  const [loading, setLoading] = useState(false);
  const [states,  setStates]  = useState([]);

  const fetchAll = useCallback(async (s, e) => {
    setLoading(true);
    try {
      setStates(await api.states(s, e));
    } catch { showToast('Failed to fetch state data', 'error'); }
    finally { setLoading(false); }
  }, [showToast]);

  useEffect(() => { fetchAll(start, end); }, [start, end, fetchAll]);

  return (
    <div className="page-body">
      <div className="page-title">States</div>
      <div className="page-subtitle">Revenue, bills and customers broken down by state</div>
      <DateBar start={start} end={end} preset={preset} setStart={setStart} setEnd={setEnd} setPreset={setPreset} loading={loading} />
      <StateTable data={states} start={start} end={end} />
    </div>
  );
}
